import React from "react";

import styled from "styled-components";

import { EditorTypography2 } from "UI/FnrTextEditor/EditorTypography2";

import { useGetHomeSettings } from "../../API/queries";
import { useGetBackgroundColorData } from "../../API/queryHooks";

const AboutSection = () => {
  const { data: homeSettings } = useGetHomeSettings();
  const { textColor } = useGetBackgroundColorData();
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
  };

  if (homeSettings?.aboutUs === "") {
    return null;
  }

  return (
    <AboutContainer>
      <CenteredContent>
        <AboutContent $textColor={textColor}>
          {homeSettings?.aboutUs && (
            <>
              <AboutTitle>{homeSettings?.aboutUsHeading || ""}</AboutTitle>
              <AboutText
                dangerouslySetInnerHTML={createMarkup(
                  homeSettings?.aboutUs || ""
                )}
              />
            </>
          )}
        </AboutContent>
      </CenteredContent>
    </AboutContainer>
  );
};

const AboutContainer = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
`;

const CenteredContent = styled.div`
  padding: 2rem 4rem;
  display: flex;
  justify-content: space-between;
  /* align-items: flex-end; */
  width: 100%;
  max-width: 1200px;
  gap: 2rem;

  @media (max-width: 768px) {
    padding: 1.5rem 2rem;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 4rem;
  }

  @media (max-width: 480px) {
    padding: 1rem;
    gap: 1rem;
  }
`;

const AboutContent = styled.div`
  flex: 1;
  color: ${({ $textColor }) => $textColor};
`;

const AboutTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: inherit;

  @media (max-width: 768px) {
    text-align: center;
  }
`;
const AboutText = styled(EditorTypography2)`
  font-size: 19px;
  font-weight: 400;

  p {
    line-height: 1.3;
  }
`;

export default AboutSection;
